import { mergeWith } from "./useDataStoreMiro";


export function convertObjectToData<Type>(data: any): Type {
    const result = mergeWith({}, data, converterCustomizer);
    return result;
}
function converterCustomizer(objValue: any, srcValue: any, key: string, object: any, source: any) {
    if (key.startsWith("_") && Array.isArray(srcValue) && key !== "_order") {
        const result: { [key: string]: any } = { _order: [] }
        for (const item of srcValue) {
            result[item.id] = convertObjectToData(item);
            result._order.push(item.id);
        }
        return result;
    }
}

